import React, { useState } from "react";
import BackBtn from "../../common/backBTN";
import DatePickerPopup from "../../common/DatePickerPopup";
import NoData from "../../common/NoData";

function AccountRecord({ transactionData = [] }) {
  // ✅ States
  const [selectedDateRange, setSelectedDateRange] = useState({ start: "", end: "" });
  const [showPicker, setShowPicker] = useState(false);

  // ✅ Safe numeric formatting helper
  const formatAmount = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };
  const safeData = Array.isArray(transactionData) ? transactionData : [];

  // ✅ Date range filter helper
  const isDateInRange = (date, range) => {
    if (!range.start || !range.end) return true;
    const d = new Date(date);
    const s = new Date(range.start);
    const e = new Date(range.end);
    return d >= s && d <= e;
  };

  // ✅ Filter by bonus-related actions + date range
  const filteredData = safeData
    // .filter((txn) =>
    //   ["freeSpin", "bonus", "rebate-bonus", "adjustment"].includes(txn.action)
    // )
    .filter((txn) => isDateInRange(txn.created_at, selectedDateRange));

  // ✅ Handle date confirmation from popup
  const handleConfirmDate = (range) => {
    setSelectedDateRange(range);
    setShowPicker(false);
  };

  // ✅ Display readable date range
  const displayDateRange =
    selectedDateRange.start && selectedDateRange.end
      ? `${new Date(selectedDateRange.start).toLocaleDateString("en-GB", {
          month: "2-digit",
          day: "2-digit",
        })} - ${new Date(selectedDateRange.end).toLocaleDateString("en-GB", {
          month: "2-digit",
          day: "2-digit",
        })}`
      : "Select Date";

  return (
    <div id="mc-animate-container" className="v-base v-detail-base fade-enter-done">
      <div className="mc-transaction-record-root mtrr-container">
        {/* ==== Header ==== */}
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-record mc-default-header am-navbar am-navbar-light"
          >
            <BackBtn />
            <div className="am-navbar-title">Account Record</div>
            <div className="am-navbar-right" />
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>

        {/* ==== Filter Button + Date ==== */}
        <div className="mc-filter-container name-filter">
          <div className="am-flexbox am-flexbox-align-middle mc-trans-filter mc-filter">
            <div className="am-flexbox am-flexbox-align-middle mc-trans-filter">
              <a
                role="button"
                className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
              >
                <svg className="am-icon am-icon-down am-icon-xxs" aria-hidden="true">
                  <use xlinkHref="#down" />
                </svg>
                <span>All</span>
              </a>

              <div className="flex-shrink1 filter-time-btn">
                <a
                  role="button"
                  className="am-button am-button-ghost am-button-small am-button-inline am-button-icon"
                  style={{ flex: "0 0 50%" }}
                  onClick={() => setShowPicker(true)}
                >
                  <svg
                    className="am-icon am-icon-calendar_c4db3b67 am-icon-xxs"
                    aria-hidden="true"
                  >
                    <use xlinkHref="#calendar_c4db3b67" />
                  </svg>
                  <span>{displayDateRange}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* ==== Records List ==== */}
        <div className="records-list-root">
          <div
            className="list-wrapper"
            style={{ height: "calc(100 * var(--vh, 1vh) - 88.46px)" }}
          >
            <ul className="scroll-inner-container">
              {filteredData.length === 0 ? (
               <NoData/>
              ) : (
                filteredData.map((txn, i) => (
                  <li key={i}>
                    <div className="rr-container">
                      {/* ==== Header ==== */}
                      <div className="tr-item-header">
                        <div className="am-flexbox am-flexbox-dir-row am-flexbox-justify-between am-flexbox-align-middle">
                          <div className="tr-item">
                            <span className="record-icon-ticket" />
                            <span className="tr-item-title">
                              {txn.title || txn.action.replace("-", " ")}
                            </span>
                          </div>
                          <span className="tr-item-time">
                            {new Date(txn.created_at).toLocaleString("en-GB", {
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                            })}
                          </span>
                        </div>
                      </div>

                      {/* ==== Content ==== */}
                      <div className="tr-item-content">
                        <div className="tr-item-detail">
                          <div className="tr-item-content-item">
                            <div className="tic-code">
                              Order no.: {txn.order_id || txn.id || "-"}
                            </div>
                            <div className="tic-remark false">
                              {txn.remark || "Applied"}
                              {txn.remark && (
                                <p className={txn.order_id || ""}>{txn.remark}</p>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* ==== Footer ==== */}
                        <div className="tr-item-content-item tic-footer">
                          <div>
                            <span className="tic-footer-title number-mc">
                              Balance
                            </span>
                            <span className="tic-footer-amount number-mc">
                              {formatAmount(txn.balance)}
                            </span>
                          </div>
                          <div>
                            <span className="tic-footer-title number-mc">
                              Transaction amount
                            </span>
                            <span
                              className={`tic-footer-amount number-mc ${
                                parseFloat(txn.amount) >= 0
                                  ? "color-green-in"
                                  : "color-red-out"
                              }`}
                            >
                              {formatAmount(txn.amount)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))
              )}
            </ul>
          </div>
        </div>

        {/* ==== DatePicker Popup ==== */}
        <DatePickerPopup
          visible={showPicker}
          onClose={() => setShowPicker(false)}
          onConfirm={handleConfirmDate}
        />
      </div>
    </div>
  );
}

export default AccountRecord;
